import {
	AfterViewChecked,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	contentChildren,
	ElementRef,
	viewChild,
} from '@angular/core';
import { TooltipPosition } from '@angular/material/tooltip';

@Component({
	selector: 'schir-int-client-more-button',
	templateUrl: './more-button.component.html',
	styleUrls: ['./more-button.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class MoreButtonComponent implements AfterViewChecked {
	readonly contentButtons = contentChildren<ElementRef>('button');
	numberOfButtons: number;

	isOpenByClick: boolean = false;

	readonly moreButtonsContainer = viewChild<ElementRef>('moreButtonsContainer');
	private readonly defaultTooltip = 'Weitere Funktionen';
	tooltip: string = this.defaultTooltip;
	private readonly defaultTooltipPosition = 'right';
	position: TooltipPosition = this.defaultTooltipPosition;

	constructor(private changeDetector: ChangeDetectorRef) {}

	ngAfterViewChecked() {
		this.setNumberOfButtons(this.contentButtons().length);
	}

	public setNumberOfButtons(numberOfButtons: number) {
		this.numberOfButtons = numberOfButtons;
		this.changeDetector.detectChanges();
	}

	focusChanged(event) {
		if (this.moreButtonsContainer().nativeElement.contains(event.relatedTarget)) {
			this.tooltip =
				event.relatedTarget.getAttribute('aria-label') == this.defaultTooltip ? this.defaultTooltip : null;
		} else {
			this.hideMore();
			this.tooltip = this.defaultTooltip;
		}
	}

	moreButtonClicked() {
		this.isOpenByClick = !this.isOpenByClick;
		if (this.isOpenByClick) {
			this.showMore();
		} else {
			this.hideMore();
		}
	}

	showMore() {
		this.moreButtonsContainer().nativeElement.style.display = 'flex';
	}

	hideMore() {
		if (!this.isOpenByClick) {
			this.moreButtonsContainer().nativeElement.style.display = 'none';
		}
		this.tooltip = this.defaultTooltip;
	}

	mouseMovedToMore() {
		this.tooltip = null;
	}
}
